import BaseResource from './BaseResource';

export default class ArtworkResource extends BaseResource {
  constructor() {
    super({ url: '/api/artwork' });
  }

  editorUrl() {
    return super
      .get({ url: `${this.url}/editor` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  downloadPdf(id) {
    return super
      .get({ url: `/api/files/${id}/download`, responseType: 'blob' })
      .then((response) => response)
      .catch((error) => error.response);
  }

  load(id) {
    return super
      .get({ url: `${this.url}/documents/${id}/download` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
